{
  "schemaVersion": 1,
  "slug": "sentry",
  "name": "Sentry",
  "description": "Investigate errors, releases, and production issues.",
  "categories": [
    "developer"
  ],
  "featured": false,
  "branding": {
    "logoUrl": "/brands/apps/sentry.svg",
    "darkLogoUrl": "/brands/apps/sentry-dark.svg"
  },
  "urlPatterns": [
    "https://mcp.sentry.dev/*"
  ],
  "methods": [
    {
      "key": "mcp-oauth",
      "transport": "mcp_remote",
      "auth": "oauth",
      "ownershipModes": [
        "customer",
        "dcr"
      ],
      "whenToUse": "Use the provider-hosted connection for the quickest setup.",
      "defaults": {
        "serverUrl": "https://mcp.sentry.dev/mcp",
        "discoveryUrl": "https://sentry.io/.well-known/oauth-authorization-server"
      },
      "guidanceMd": "Connect the Sentry organization and projects agents need for incident work.",
      "riskTier": "S2",
      "requiredResourceFilters": [
        "organization",
        "project",
        "environment"
      ]
    }
  ],
  "docsUrl": "https://mcp.sentry.dev/.well-known/oauth-authorization-server",
  "redirectConstraints": "https-or-loopback-http"
}
